import { ReportContainerComponent } from './report-container/report-container.component';

export { ReportContainerComponent };

export const containerComponents = [ReportContainerComponent];
